import { useState } from 'react';

export interface IGovernanceListQuery {
  page: number;
  perPage: number;
  from?: string;
  to?: string;
}

export interface IGovernancePaging {
  page?: number;
  perPage?: number;
  total?: number;
  totalElements?: number;
}

export const overviewTraderRequestQuery: IGovernanceListQuery = { page: 1, perPage: 100 };

export const governanceListParams = (query: IGovernanceListQuery) => {
  const params: Record<string, string | number> = {
    page: query.page,
    perPage: query.perPage,
  };
  if (query.from) {
    params.from = query.from;
  }
  if (query.to) {
    params.to = query.to;
  }
  return params;
};

export const withGovernanceListPage = (query: IGovernanceListQuery, page: number): IGovernanceListQuery => ({
  ...query,
  page,
});

export const withGovernanceListPerPage = (query: IGovernanceListQuery, perPage: number): IGovernanceListQuery => ({
  ...query,
  page: 1,
  perPage,
});

export const withGovernanceListDate = (
  query: IGovernanceListQuery,
  field: 'from' | 'to',
  value: string
): IGovernanceListQuery => ({
  ...query,
  page: 1,
  [field]: value || undefined,
});

export const toTablePaging = (paging?: IGovernancePaging) => ({
  page: paging?.page ?? 1,
  per_page: paging?.perPage ?? 20,
  total: paging?.total ?? 0,
  total_elements: paging?.totalElements ?? 0,
});

export const useGovernanceListQuery = () => {
  const [query, setQuery] = useState<IGovernanceListQuery>({ page: 1, perPage: 20 });

  return {
    query,
    setPage: (page: number) => setQuery(current => withGovernanceListPage(current, page)),
    setPerPage: (perPage: number) => setQuery(current => withGovernanceListPerPage(current, perPage)),
    setFrom: (value: string) => setQuery(current => withGovernanceListDate(current, 'from', value)),
    setTo: (value: string) => setQuery(current => withGovernanceListDate(current, 'to', value)),
  };
};
